import type { CategoryTreeBuildDto } from '@/api/gen/_model/categoryTreeBuildDto';

/** 과목 트리에서 `categoryTreeId` 의 과목명을 찾는다. `curriculumList.subject` 는 코드가 아니라 이름이다. */
export const findSubjectName = (
  subjectTree: CategoryTreeBuildDto[],
  categoryTreeId: string,
): string | undefined => {
  for (const node of subjectTree) {
    if (node.categoryTreeId === categoryTreeId) return node.name;

    const found = findSubjectName(node.children ?? [], categoryTreeId);
    if (found) return found;
  }
  return undefined;
};
